import _ from 'lodash';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { LoadingService } from 'app/core/services/loading.service';
import { tap } from 'rxjs/operators';
import * as ExcelJS from 'exceljs/dist/exceljs';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AuctionManageService {

  public AuctionTypeSilent = 0
  public AuctionTypeLive = 1

  public AUCTION_CONTROL_MANUAL = 0
  public AUCTION_CONTROL_AUTO = 1

  public AuctionStatusBiddingOpen = 0
  public AuctionStatusBiddingPaused = 1
  public AuctionStatusFinalized = 2
  public OnlineBiddingNotEnabled = 3
  public OnlineBiddingTypeLive = 4
  public AuctionStatusHidden = 5;

  public totalAuctions = 0;
  public activeAuctions = 0;
  public pausedAuctions = 0;
  public endedAuctions = 0;

  public auction = null;
  public filteredByCategoty = []
  public filteredItems = []
  public items = []
  public auctionItemsFilterActive = 0

  public searchQuery = ''
  public category = 'All Items'

  public takeUntilSubject = new Subject();

  filterAuctionsItems(){
    switch(this.category){
      case 'All Items':
          this.filteredItems = this.items
          this.filteredByCategoty = [...this.items]
          break;
      case 'Items With No Bids':
        this.filteredItems = this.items.filter((item)=>{
          const currentBids = _.isNull(item.currentBids)?[]:item.currentBids;
          if(currentBids.length < 1 ){
            return item
          }
        })
          this.filteredByCategoty = [...this.filteredItems]
          break
      case 'Items Pending Payment':
          this.filteredItems = _.filter(this.items, (item: any) => {
            const soldItems = _.isNull(item.soldItems)?[]:item.soldItems;
            let pendingItem = soldItems.find(soldItem=>soldItem.status == 1)
              if(pendingItem){
                 return item
              }
          })
          this.filteredByCategoty = [...this.filteredItems] 
          break
      case 'Paid Items':
        this.filteredItems = _.filter(this.items, (item: any) => {
          const soldItems = _.isNull(item.soldItems)?[]:item.soldItems;
          let paidItem = soldItems.find(soldItem=>soldItem.status == 0)
            if(paidItem){
               return item
            }
        })
        this.filteredByCategoty = [...this.filteredItems] 
          break;
      case 'Unsold Items':
        this.filteredItems = this.items.filter(opt=>(opt.soldCount < opt.count));
        this.filteredByCategoty = [...this.filteredItems] 
        break;
      case 'Sold Out Items':
        this.filteredItems = this.items.filter(opt=>(opt.soldCount == opt.count));
        this.filteredByCategoty = [...this.filteredItems] 
        break;
      case 'Items With No Activity (Bid/Buy)':
        this.filteredItems = this.items.filter(opt=>(opt.soldCount == 0 && !opt.currentBids && !opt.currentAutoBids ));
        this.filteredByCategoty = [...this.filteredItems] 
        break;
      default:
        this.filteredItems = this.items.filter(item=>item.categories && item.categories.length > 0 && item.categories.includes(this.category))
        this.filteredByCategoty = [...this.filteredItems]
    }
    this.filteredItems = _.filter(this.filteredByCategoty, (item: any) => {
          return _.includes(item.name.toLowerCase(), this.searchQuery.toLowerCase())
      });
  }

  getAuctionStatus(auction){
    let auctionData = auction.campaignTypeData

      var statusData = {
          "status"    : this.AuctionStatusBiddingOpen,
          "startsIn"  : 0,
          "type"      : auctionData.auctionType
      }

      if(auctionData.auctionStatus == this.AuctionStatusFinalized) {
          statusData.status = this.AuctionStatusFinalized
      } else if(auctionData.auctionControlMethod == this.AUCTION_CONTROL_MANUAL) {
          statusData.status = auctionData.auctionStatus
      } else {
          var auctionStartTime = auctionData.auctionStartTime
          var auctionEndTime = auctionData.auctionEndTime
          var timeNow = Math.floor(new Date().getTime() / 1000)
          if(auctionStartTime > timeNow) {
              statusData.status = this.AuctionStatusBiddingPaused
              statusData.startsIn = auctionStartTime - timeNow
          } else if(auctionEndTime < timeNow && auctionEndTime != 0) {
              statusData.status = this.AuctionStatusBiddingPaused
          } else {
              statusData.status = auction.isDefault ? this.AuctionStatusBiddingOpen : this.AuctionStatusHidden
          }
      }
      return statusData
  }

  getAuctionStatusHtml(auction){

    let auctionStatus = this.getAuctionStatus(auction)

    let statusHtml = ''
    if(auctionStatus.type == 1){
      return "<span class='badge-success caption custom-budge d-flex align-items-center live-auction'>Live Auction</span>"
    }

    switch(auctionStatus.status){
      case this.AuctionStatusBiddingOpen:
        if(auction.isDefault){
          statusHtml ="<span class='badge-success caption custom-budge d-flex align-items-center'>Active</span>"
        } else{
          statusHtml = "<span class='badge-warning caption custom-budge d-flex align-items-center'>Hidden</span>"
        }
        
        break
      case this.AuctionStatusBiddingPaused:
        statusHtml = "<span class='custom-badge-secondary caption custom-budge d-flex align-items-center' >Paused</span>"
          break
      case this.AuctionStatusFinalized:
        statusHtml = "<span class='badge-danger caption custom-budge d-flex align-items-center'>Ended</span>"
          break
  }

  return statusHtml
  }

  setAuctionStatus(campaignData){
    var params = {
      "campaignId": campaignData.id,
  }
  var auctionStatus = this.getAuctionStatus(campaignData)
  switch(auctionStatus.status){
      case this.AuctionStatusBiddingOpen:
          params["status"] = this.AuctionStatusBiddingPaused
          break
      case this.AuctionStatusBiddingPaused:
          params["status"] = this.AuctionStatusBiddingOpen
          break
      case this.AuctionStatusFinalized:
        window['toastr'].error("Auction has already been ended")
          return 
  }

    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/auction/pauseResumeBidding', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  onCloseAuction(campaignData){
    var params = {
      "campaignId": campaignData.id,
    }

    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];

    return this.http.post('/api/auction/finalize', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  allItemsClick(){
    this.filteredItems = this.items
    this.filteredByCategoty = this.items
  }

  onActiveClick(){
    let auctionStatus =  this.getAuctionStatus(this.auction)
    this.filteredItems = _.filter(this.items, (item: any) => {
      if (item.soldCount < item.count && auctionStatus.status == 0) {
        return item
      }
    })

    this.filteredByCategoty =  this.filteredItems = _.filter(this.items, (item: any) => {
      if (item.soldCount < item.count && auctionStatus.status == 0) {
        return item
      }
    })
  }

  onSoldClick(){
    let auctionStatus =  this.getAuctionStatus(this.auction)

    this.filteredItems = _.filter(this.items, (item: any) => {
      if (item.soldCount >= item.count || auctionStatus.status == 2) {
        return item
      }
    })

    this.filteredByCategoty =_.filter(this.items, (item: any) => {
      if (item.soldCount >= item.count || auctionStatus.status == 2) {
        return item
      }
    })
  }

  onNotPaidClick(){
    let auctionStatus =  this.getAuctionStatus(this.auction)

    this.filteredItems = _.filter(this.items, (item: any) => {
      if (item.soldCount >= item.count || auctionStatus.status == 2) {
        return item
      }
    })

    this.filteredByCategoty = _.filter(this.items, (item: any) => {
      if (item.soldCount >= item.count || auctionStatus.status == 2) {
        return item
      }
    })
  }

  onFilterByCategory(category){
    this.filteredItems = _.filter(this.items, (item: any) => {
      if (item.categories.includes(category)) {
        return item
      }
    })

    this.filteredByCategoty = _.filter(this.items, (item: any) => {
      if (item.categories.includes(category)) {
        return item
      }
    })
  }

  getAuction(id){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `campaignId=${id}`
    ];
    return this.http.post('api/auction/item/all', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getAvailableAuctionsList(orgHandle){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({"orgHandle":"home", "campaignType": 4}))}`
    ];
    
    return this.http.post('/api/campaign/available/list', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateDeliveryStatus(transactionID, delivered): Observable<any> {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({"id": transactionID, delivered: !delivered}))}`
    ];
    return this.http.post('/api/transaction/markDelivered', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getAuctionItemDetails({campaignId, presetId}){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({campaignId, presetId}))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/auction/item/admin/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  getAuctionBidders(auction) { 
    const presetOptions = auction.campaignTypeData.presetOptions

    let allSoldOrBiddedItems = [];

    presetOptions.forEach((auctionItem) => {
      if(auctionItem.status == 1) {
        return false;
      }

      if(auctionItem.currentBids) {
        auctionItem.currentBids.forEach(function(bid){
          if(bid.userInfo == undefined || bid.userInfo == null) {
            return false;
          }
          allSoldOrBiddedItems.push(bid)
        })
      }

      if(auctionItem.soldItems) {
        auctionItem.soldItems.forEach(function(soldItem){
          if(soldItem.userInfo == undefined || soldItem.userInfo == null) {
            return false;
          }
          allSoldOrBiddedItems.push(soldItem)
        })
      }
    })

    const additionalInfo = {
      desc: auction.additionalInfoDesc,
      selectDesc: auction.additionalInfoSelectDesc,
      intid: auction.intid
    }

    const uniqSoldOrBiddedItems = _.uniqBy(allSoldOrBiddedItems, item => item.userInfo.id);
    const mapSoldOrBiddedItems = _.map(uniqSoldOrBiddedItems, (bidInfo) => {
      return { allItems: [], bidInfo, additionalInfo};
    })

    const result = _.map(mapSoldOrBiddedItems, ({allItems, bidInfo, additionalInfo}) => {
      _.forEach(presetOptions, (presetOption) => {

        const currentBid = _.find(presetOption.currentBids, (currentBid) => {
          const {id} = currentBid.userInfo || { id: null };

          return bidInfo.userInfo.id == id;
        }) || null;

        if(currentBid) {
         return allItems.push(presetOption);
        }

        const soldItem = _.find(presetOption.soldItems, (soldItem) => {
          const {id} = soldItem.userInfo || { id: null };
          return bidInfo.userInfo.id == id;
        }) || null;

        if(soldItem) {
          return allItems.push(presetOption);
        }
      })
      return {allItems, bidInfo, additionalInfo};
    })

    return result;
  }

  getBidderData(campaignId, userId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({campaignId, userId}))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/auction/bidder/data', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  addCommasToNumber(number) {
    return window['utils'].getAmountDisplay(number);
  }

  onDownloadBidders(campaignData){
    let auctionBids = []
    let auctionTopBidders = {}
    let currentAuctionItemForExport = {} 
    var additionalImages = ""
    var auctionItems = []
    let auctionBuyers = []

    var decodeHtmlEntity = function(str) {
      return str.replace(/&#(\d+);/g, function(match, dec) {
        return String.fromCharCode(dec);
      });
    };

    var getAuctionItemSoldStatus = function(status) {
      if(status == 0) {
        return "Paid"
      } 
      return "Pending"
    }

    campaignData.campaignTypeData.presetOptions.forEach((auctionItem)=>{
      if(auctionItem.currentBids){
        auctionItem.currentBids.forEach(function(bid){
          if(bid.userInfo == undefined || bid.userInfo == null) {
            return
          }
          const streetAddress = bid.userInfo.address || {};
          const streetAddressText = window['utils'].getStreetAddressText(streetAddress).trim()
          const phoneNumber = bid.userInfo.phone || '';
          // Bids Sheet
          auctionBids.push({
            "Item Code" : decodeHtmlEntity(auctionItem.itemCode),
            "Item Name" : decodeHtmlEntity(auctionItem.name),
            "Bidder Name": bid.userInfo.name,
            "Bidder Email" : bid.userInfo.email,
            "Street Address": streetAddressText,
            "Bidder Phone": phoneNumber,
            "Amount": bid.amount, 
            "Value": auctionItem.valueProvided,
            "Date":  moment(new Date(bid.created)).format("YYYY/MM/DD h:mm a"),
            "WinningBid": bid.winningBid,
          });

          window['orgMain'].auctionBidders.push({
            "itemCode" : decodeHtmlEntity(auctionItem.itemCode),
            "itemName" : decodeHtmlEntity(auctionItem.name),
            "bidderName": bid.userInfo.name,
            "bidderEmail" : bid.userInfo.email,
            "bidderPhone" : bid.userInfo.phone,
            "amount" : bid.amount,
            "winningBid": bid.winningBid,
            "bidId":bid.id
          })
          
          // Top Bidders Sheet
          const auctionTopBiddersObj = {
            "Item Code" : decodeHtmlEntity(auctionItem.itemCode),
            "Item Name" : decodeHtmlEntity(auctionItem.name),
            "Bidder Name": bid.userInfo.name,
            "Bidder Email" : bid.userInfo.email,
            "Street Address": streetAddressText,
            "Bidder Phone": phoneNumber,
            "Amount": bid.amount, 
            "Value": auctionItem.valueProvided,
          }

          if(!auctionTopBidders[auctionItem.id]){
            auctionTopBidders[auctionItem.id] = auctionTopBiddersObj
          } else if(auctionTopBidders[auctionItem.id] < bid.amount){
            auctionTopBidders[auctionItem.id] = auctionTopBiddersObj
          }
        })
      }

      additionalImages = window['utils'].isValidNonEmptyArray(auctionItem.additionalImages) ?
        auctionItem.additionalImages.join(", "): "";

      // Sold Items Sheet
      if(window['utils'].isValidNonEmptyArray(auctionItem.soldItems)){
        auctionItem.soldItems.forEach(function(soldEntry) {
          var auctionWinner = "No"

          if(soldEntry.isWinningBid) {
            auctionWinner = "Yes"    
          }
          const streetAddress = soldEntry.userInfo.address || {};
          const streetAddressText = window['utils'].getStreetAddressText(streetAddress).trim()
          const phoneNumber = soldEntry.userInfo.phone || '';

          auctionBuyers.push({
            "Item Code" : decodeHtmlEntity(auctionItem.itemCode),
            "Item Name" : decodeHtmlEntity(auctionItem.name),
            "Bidder Name": soldEntry.userInfo.name,
            "Bidder Email" : soldEntry.userInfo.email,           
            "Street Address": streetAddressText,
            "Bidder Phone": phoneNumber,
            "Amount": soldEntry.amount,
            "Value": auctionItem.valueProvided,
            "Payment": getAuctionItemSoldStatus(soldEntry.status),
            "Auction Winner": auctionWinner,
            "Delivery": soldEntry.delivered ? 'Done': 'Pending',
          })
        })
      }

      currentAuctionItemForExport = {
        "name": decodeHtmlEntity(auctionItem.name),
        "imageUrl": auctionItem.imageUrl,
        "additionalImages": additionalImages,
        "thumbnailUrl": auctionItem.thumbnailUrl,
        "count": auctionItem.count,
        "minBid": auctionItem.minBid,
        "bidIncrement": auctionItem.bidIncrement,
        "valueProvided": auctionItem.valueProvided,
      }

      if (campaignData.type === 4 && campaignData.campaignTypeData.auctionType === 0) {
        currentAuctionItemForExport = window['$'].extend(currentAuctionItemForExport, {
            buyItNowOnlyItem: auctionItem.buyItNowOnlyItem,
            buyItNowEnabled: auctionItem.buyItNowEnabled,
            buyItNowAmount: auctionItem.buyItNowAmount
        });
      }

      var categories = ""
      if(window['utils'].isValidNonEmptyArray(auctionItem.categories)){
        categories = auctionItem.categories.join(", ")
      } 

      categories = decodeHtmlEntity(categories)

      currentAuctionItemForExport = window['$'].extend(currentAuctionItemForExport, {
        "collectSalesTax" : auctionItem.collectSalesTax,
        "salesTax" : auctionItem.salesTax,
        "categories" : categories,
        "desc" : decodeHtmlEntity(auctionItem.desc),
        "summary" : decodeHtmlEntity(auctionItem.summary),
        "memo" : auctionItem.memo || "",
        "featured" : auctionItem.featured,
        "donatedByName" : auctionItem.donatedByName || "",
        "displayDonatedBy": auctionItem.displayDonatedBy,
        "itemCode" : auctionItem.itemCode || "",
        "displayToDonors" : auctionItem.displayToDonors,
        "addVideo": auctionItem.addVideo,
        "videoProvider": auctionItem.videoProvider,
        "videoUrl": auctionItem.videoUrl,
      });

      const {additionalInfoRequired, additionalInfoDesc, additionalInfoDetail,
        additionalInfoSelectRequired, additionalInfoSelectDesc, additionalInfoSelect} = auctionItem;

      if(additionalInfoRequired) {
        currentAuctionItemForExport = window['$'].extend(currentAuctionItemForExport, {
          additionalInfoRequired: additionalInfoRequired,
          additionalInfoDesc: additionalInfoDesc,
          additionalInfoDetail: additionalInfoDetail
        });
      }

      if(additionalInfoSelectRequired) {
        currentAuctionItemForExport = window['$'].extend(currentAuctionItemForExport, {
          additionalInfoSelectRequired: additionalInfoSelectRequired,
          additionalInfoSelectDesc: additionalInfoSelectDesc,
          additionalInfoSelect: additionalInfoSelect.join(",")
        });
      }

      currentAuctionItemForExport = window['$'].extend(currentAuctionItemForExport, {
        "currentBid" : auctionItem.currentBid,
        "soldCount" : auctionItem.soldCount,
      });

      auctionItems.push(currentAuctionItemForExport)
    })

    const auctionData = {
      bids: auctionBids,
      topBidders: auctionTopBidders,
      auctionItems: auctionItems,
      auctionBuyers: auctionBuyers
    }
    this.downloadBiddersExcel(auctionData, campaignData)
  }

  private downloadBiddersExcel(auctionData, campaignData) {
    const { intid, type: campaignType, campaignTypeData: { auctionType }} = campaignData;
    const type = (campaignType === 4 && auctionType === 0) ? 'silent' : 'live';

    const { bids, topBidders, auctionItems, auctionBuyers } = auctionData;
    const workbook = new ExcelJS.Workbook();

    const bidsSheet = workbook.addWorksheet('Bids');
    const bidsSheetColumns = [
      { header: 'Item Code'},
      { header: 'Item Name', width: 20},
      { header: 'Bidder Name', width: 20},
      { header: 'Bidder Email', width: 20},
      { header: 'Street Address', width: 20 },
      { header: 'Bidder Phone', width: 15 },
      { header: 'Amount', style: { numFmt: '$#,##0.00' } }, // add USD currency format to the amount column
      { header: 'Value', style: { numFmt: '$#,##0.00' } },
      { header: 'Date' },
      { header: 'Winning Bid'},
    ];
    bidsSheet.columns = bidsSheetColumns;

    bids.forEach((bid) => {
      const values = Object.values(bid);
      bidsSheet.addRow(values)
    })

    
    const topBiddersSheet = workbook.addWorksheet('Top Bidders');
    topBiddersSheet.columns = bidsSheetColumns.slice(0, -1); // remove last 'winning bid' column

    const topBiddersKeys = Object.keys(topBidders)
    topBiddersKeys.forEach((key) => {
      const values = Object.values(topBidders[key]);
      topBiddersSheet.addRow(values)
    })


    const winnersSheet = workbook.addWorksheet('Auction Winners');
    winnersSheet.columns = bidsSheetColumns.slice(0, -1);

    bids.forEach((bid) => {
      if(bid.WinningBid) {
        const values = Object.values(bid).slice(0, -1); // remove 'winning bid' value
        winnersSheet.addRow(values)
      }
    })


    const itemsSheet = workbook.addWorksheet('Auction Items');
    const itemsSheetColumns = [
      { header: 'Item Name (127 Charcter Max)', key: 'name', width: 20},
      { header: 'Image (File Name Or URL)', key: 'imageUrl'},
      { header: 'Additional Images (File name or URL, Comma seperated)', key: 'additionalImages'},
      { header: 'Thumbnail', key: 'thumbnailUrl' },
      { header: 'Total Item Count', key: 'count'},
      { header: 'Min Bid', key: 'minBid', style: { numFmt: '$#,##0.00' }},
      { header: 'Bid Increment', key: 'bidIncrement', width: 10, style: { numFmt: '$#,##0.00' }},
      { header: 'Value of  goods or services provided, if any!', key: 'valueProvided', width: 10, style: { numFmt: '$#,##0.00' }},
      { header: 'Buy It Now Only item (yes/no), buy it now price must be be set if yes.', key: 'buyItNowOnlyItem'},
      { header: 'Enable Buy it Now (yes,no)', key: 'buyItNowEnabled'},
      { header: 'Buy it Now Amount', key: 'buyItNowAmount', style: { numFmt: '$#,##0.00' }},
      { header: 'Collect sales tax for this item(yes/no)', key: 'collectSalesTax'},
      { header: 'Percentage Sales Tax', key: 'salesTax', style: { numFmt: '$#,##0.00' }},
      { header: 'Categories (comma seperated)', key: 'categories'},
      { header: 'Description (2048 characters max)', key: 'desc'},
      { header: 'Summary (128 characters max)', key: 'summary'},
      { header: 'Memo (2048 characters max)', key: 'memo'},
      { header: 'Featured (True / False)', key: 'featured'},
      { header: 'Donated By Name (64 Charcter Max)', key: 'donatedByName'},
      { header: 'Display Donated By  (True / False)', key: 'displayDonatedBy'},
      { header: 'Item Code (32 Charcter Max)', key: 'itemCode'},
      { header: 'Display To Donors (True / False)', key: 'displayToDonors'},
      { header: 'Add Video (True / False)', key: 'addVideo'},
      { header: 'Video Provider(1- YouTube, 2-Vimeo, 3- facebook, 0 - other)', key: 'videoProvider'},
      { header: 'Video Url (128 Charcter Max)', key: 'videoUrl'},
      { header: 'Any additional info required (yes/no)', key: 'additionalInfoRequired' },
      { header: 'Addtional info description', key: 'additionalInfoDesc' },
      { header: 'Instructions for additional info', key: 'additionalInfoDetail' },
      { header: 'Any additional info, to be selected by user (yes/no)', key: 'additionalInfoSelectRequired' },
      { header: 'Additional info select description', key: 'additionalInfoSelectDesc' },
      { header: 'Options to be selected (comma seperated)', key: 'additionalInfoSelect' },
      { header: 'Current Bid', key: 'currentBid', style: { numFmt: '$#,##0.00' }},
      { header: 'Sold Count', key: 'soldCount'},
    ]

    const getAllItemKeys = function(items) {
      let keyObj = {};

      items.forEach(item => {
        const itemKeys = Object.keys(item);
        
        itemKeys.forEach(key => {
          if (!keyObj.hasOwnProperty(key)) { // create a new prop if it doesn't exist
            keyObj[key] = true;
          }
        });
      });
      
      return keyObj;
    }

    const auctionItemsKeys = Object.keys(getAllItemKeys(auctionItems));
    /* Filter columns depending on keys in object */
    const filteredColumns = itemsSheetColumns.filter(column => auctionItemsKeys.includes(column.key));
    itemsSheet.columns = filteredColumns;

    // add empty string if item don't have the key that column has
    auctionItems.forEach((item) => {
      const values = _.map(itemsSheet.columns, column => _.get(item, column.key, ''));
      itemsSheet.addRow(values);
    })

    const soldItemsSheet = workbook.addWorksheet('Sold Items');
    const soldItemsSheetColumns = [
      { header: 'Item Code'},
      { header: 'Item Name', width: 20},
      { header: 'Bidder Name', width: 20},
      { header: 'Bidder Email', width: 20},
      { header: 'Street Address', width: 20 },
      { header: 'Bidder Phone', width: 15 },
      { header: 'Amount', style: { numFmt: '$#,##0.00' }},
      { header: 'Value', style: { numFmt: '$#,##0.00' }},
      { header: 'Payment'},
      { header: 'Auction Winner'},
      { header: 'Delivery'},
    ];
    soldItemsSheet.columns = soldItemsSheetColumns;

    auctionBuyers.forEach((item) => {
      const values = Object.values(item);
      soldItemsSheet.addRow(values)
    })


    const soldItemsByDonorSheet = workbook.addWorksheet('Sold Items By Donor');
    soldItemsByDonorSheet.columns = soldItemsSheetColumns;

    const sortedBuyers = _.sortBy(auctionBuyers, ['Bidder Email']);
    let prevEmail = null;

    sortedBuyers.forEach((item) => {
      const values = Object.values(item);
      const currentEmail = item['Bidder Email'];

      /* Add an empty row and donorName between different donors */
      if(currentEmail !== prevEmail) {
        let emptyValues = [];
        values.forEach(() => emptyValues.push(" "))

        const emptyRow = soldItemsByDonorSheet.addRow(emptyValues)
        emptyRow.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'ffd3d3d3'}
          };
        })

        const rowWithName = soldItemsByDonorSheet.addRow(emptyValues);
        rowWithName.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'ffd3d3d3'}
          };
        })

        soldItemsByDonorSheet.mergeCells(`A${emptyRow.number}:H${rowWithName.number}`);

        const cell = soldItemsByDonorSheet.getCell(`A${rowWithName.number}`);
        cell.value = item['Bidder Name'];
        cell.alignment = { horizontal: 'center', vertical: 'bottom' };
        cell.font = { bold: true };

        soldItemsByDonorSheet.addRow(values)
        prevEmail = _.cloneDeep(currentEmail)
      } else {
        soldItemsByDonorSheet.addRow(values)
      }
    })

    workbook.xlsx.writeBuffer().then((buffer) => {
      //const fileName = `auction_data_${intid}_${type}`;
      const fileName = 'Auction_BiddersAndItems';
      this.saveAsExcelFile(buffer, fileName);
    });
  }

  private saveAsExcelFile(buffer, fileName){
    const blob: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = fileName;
    downloadLink.click();
  }

  onDownloadBidSheet(auction){
    window['orgMain'].downloadBidSheet(auction)
  }

  onDownloadBidSheetQrt(auction){
    window['orgMain'].onDownloadBidSheetQrt(auction)
  }

  downloadBidSheetQrX4(auction){
    window['orgMain'].downloadBidSheetQrX4(auction)
  }

  deleteBidById(bidId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `bidId=${bidId}`
    ];
    return this.http.post('/api/auction/item/bid/remove', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deleteAutoBidById(autoBidId){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `autoBidId=${autoBidId}`
    ];
    return this.http.post('/api/auction/item/autobid/remove', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateAuctionBidder(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`,
    ];
    return this.http.post('/api/auction/bidder/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  loadBidActivity(campaignId: string,since: number){
    const token = this.cookieService.get('accessToken');
    const p = {
      "campaignId": campaignId,
      "since": since,
    }
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(p))}`,
    ];

    return this.http.post('api/auction/bidActivity', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  loadPendingDonations(campaignId: string){
    const token = this.cookieService.get('accessToken');

    const queryParams = [
      `access_token=${token}`,
      `campaignId=${campaignId}`,
    ];

    return this.http.post('api/campaign/pending', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  loadPaidDonations(campaignId: string){
    const token = this.cookieService.get('accessToken');
    const p = {
      "campaignId": campaignId,
      "startDate": 0,
      "endDate": 0,
    }
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(p))}`,
    ];

    return this.http.post('api/campaign/donations', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    public store: Store,
    private loadingService: LoadingService,
  ) { }

}
